type Environment = 'localhost' | 'staging' | 'production' | 'preview';

// Duplicated from apps/frontend on purpose: this package must stay independent of the host app.
function getEnvironment(): Environment {
  return window.location.hostname === 'app.e2n.de' ||
    window.location.hostname === 'manager.e2n.de'
    ? 'production'
    : window.location.hostname === 'staging.e2n.de' ||
        window.location.hostname === 'manager.staging.e2n.de'
      ? 'staging'
      : window.location.hostname === 'localhost'
        ? 'localhost'
        : 'preview';
}

// TODO: points at the manager backend for now, will move to a dedicated e2n-api endpoint later.
const GRAPHQL_API_URL_PROD = 'https://api.manager.e2n.de/graphql';
const GRAPHQL_API_URL_STAGING = 'https://api.manager.staging.e2n.de/graphql';
const GRAPHQL_API_URL_LOCAL = 'http://localhost:8080/graphql';

export const graphqlApiUrl =
  getEnvironment() === 'production'
    ? GRAPHQL_API_URL_PROD
    : getEnvironment() === 'staging'
      ? GRAPHQL_API_URL_STAGING
      : GRAPHQL_API_URL_LOCAL;
